<template>
    <div style="background-color: white;">
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
                <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
                <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card flat>
            <v-toolbar class="toolbar no-display" flat dense>
                <v-toolbar-title>
                    <strong>
                        Invoice
                    </strong>
                </v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-btn class="ma-2 no-display" tile outlined color="warning" @click="print()"> <v-icon left>mdi-printer</v-icon> Print <v-icon right></v-icon> </v-btn>
            <div class="outer-div" style="border: 2px solid rgba(34,27,154,1);max-width: 80%;margin: auto;">
                <v-row dense>
                    <v-col cols="12" sm="2" md="2" class="mt-6" style="text-align: center;" v-if="vendor_details[0].vendor_logo_file">
                        <img :src="awspath + vendor_details[0].vendor_logo_file" class="logo" width="160" height="100" alt="logo" />
                    </v-col>
                    <v-col cols="12" sm="6" md="6" class="header pl-0">
                       <span style="text-decoration: underline;font-family: 'Times New Roman', Times, serif; text-underline-offset: 8px;"><b> Tax Invoice / Bill of Supply / Cash memo </b></span>
                    </v-col>
                </v-row>
                <div class="main">
                    <v-row >
                        <table class="tables">
                            <thead>
                                <th>PRN</th>
                                <th>Student Name</th>
                                <th>Standard</th>
                                <th>Division</th>
                            </thead>
                            <tbody>
                                <tr v-for="item in stud_details" :key="item.id">
                                    <td>{{item.prn}}</td>
                                    <td>{{item.first_name + " " + item.last_name}}</td>
                                    <td>{{item.standard}}</td>
                                    <td>{{item.division}}</td>
                                </tr>
                            </tbody>
                        </table>
                        <table class="tables">
                            <thead>
                                <th>Order No.</th>
                                <th>Order Date</th>
                                <th>Invoice No.</th>
                                <th>Invoice Date</th>
                            </thead>
                            <tbody>
                                <tr v-for="item in order_details" :key="item.id">
                                    <td>{{item.order_id}}</td>
                                    <td>{{item.order_date}}</td>
                                    <td>{{item.invoice_number}}</td>
                                    <td>{{item.invoice_date}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </v-row>
                    <v-row dense style="margin-top: 30px;">
                        <v-col cols="12" sm="4" md="4" class="vendor-info" style="margin-left: 65px;">
                            <b class="pl-3">Sold By</b>
                            <div class="pl-3 pt-2">{{ vendor_details[0].company_name }}</div>
                            <p class="pl-3 pt-2">{{ vendor_details[0].address }}</p>
                            <div style="line-height: 100%;">
                                <p class="pl-3"><b>PAN No. </b>{{ vendor_details[0].pan_no }}</p>
                                <p class="pl-3"><b>GST Registration No. </b>{{ vendor_details[0].gst_no }}</p> 
                                <p class="pl-3"><b>QR Code :</b></p> 
                                <p class="pl-4"><qrcode-vue :value=" formatVendorDetails(qr_details[0])" :size="90"></qrcode-vue> </p>
                            </div>                     
                        </v-col>
                        <v-col cols="12" sm="3" md="3"></v-col>
                        <v-col cols="12" sm="4" md="4" class="stud-details">
                            <b class="pl-3">Billing Address</b>
                            <p class="pl-3 pt-2">{{ stud_details[0].stud_local_address }}</p>
                            <b class="pl-3">Shipping Address</b>
                            <p class="pl-3 pt-2">{{ order_details[0].delivery_address }}</p>
                        </v-col>
                    </v-row>
                    <br>
                    <table class="details-table" v-if="order_item_details != ''"  >
                        <thead>
                            <tr>
                                <th>Sr. <br> No.</th>
                                <th>Item <br>Name</th>
                                <th>Item <br>Code</th>
                                <th>ISBN</th>
                                <th>Item <br>Category</th>
                                <th>Item <br>Description</th>
                                <th>Size <br> Label Type</th>
                                <th>Size <br> Label</th>
                                <th>Price</th>
                                <th>Quantity</th>
                                <th>Net <br> Amount</th>
                                <th>Tax <br>Rate</th>
                                <th>Tax <br> Amount</th>           
                                <th>Total <br> Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in order_item_details" :key="index">
                                <td>{{ item.sr_no }}</td>
                                <td>{{ item.item_name }}</td>
                                <td>{{ item.item_code }}</td>
                                <td>{{ item.isbn }}</td>
                                <td>{{ item.item_category }}</td>
                                <td>{{ item.item_description }}</td>
                                <td>{{ item.size_label_type }}</td>
                                <td>{{ item.size_label }}</td>
                                <td>{{ item.price }}</td>
                                <td>{{ item.quantity }}</td>
                                <td>{{ item.net_amount }}</td>
                                <td>{{ item.tax }}%</td>
                                <td>{{ calculateTaxAmount(item.net_amount, item.tax) }}</td>
                                <td>{{ item.total }}</td>
                            </tr>
                            <tr>
                                <td colspan="12" style="text-align: right;"><b>TOTAL</b></td>
                                <td>{{ totalTaxAmount }}</td>
                                <td>{{ TotalAmount }}</td>                            
                            </tr>
                            <tr>
                                <td colspan="13" style="text-align: right;"><b>DELIVERY CHARGES</b></td>
                                <td>{{ totalDeliveryCharges }}</td>
                            </tr>
                            <tr>
                                <td colspan="13" style="text-align: right;"><b>GRAND TOTAL</b></td>
                                <td><b>{{ grandTotalAmount }}</b></td>
                            </tr>
                            <tr>
                                <td colspan="14" style="text-align: left;padding-left: 100px;"><b>Amount in words: {{ grandTotalAmountInWords }}</b></td>
                            </tr>
                            <tr>
                                <td colspan="14" style="text-align: center;" class="sign" ><b>For {{ vendor_details[0].company_name }}</b>
                                <br><br>
                                <img :src="awspath + vendor_details[0].vendor_signature_file" width="80" height="50" alt="sign" /><br>
                                <b>Authorised Signatory</b></td>
                            </tr>
                        </tbody>
                    </table>
                    <p class="mt-7 end-line">Whether Tax is Payable Under Reverse Charge - No</p>
                </div>
            </div>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
        </v-card>
    </div>
</template>
<script>
    import axios from "axios";
    import CryptoJS from 'crypto-js';
    import QrcodeVue from "qrcode.vue";
    import "@/assets/css/color.css";
    export default {
        components: {
            QrcodeVue,
        },
        data() {
            return {
                overlay: false,
                snackbar: false,
                color: "",
                snackbar_msg: "",
                invoice_id : null,
                order_item_details:[],
                order_details:[],
                vendor_details:[],
                stud_details:[],
                qr_details:[],
                awspath: "",
            };
        },
        watch: {
            overlay(val) {
                val = () => {
                    this.overlay = false;
                };
            },
        },
        computed: {
            totalTaxAmount() {
                return this.order_item_details.reduce((total, item) => {
                    return total + this.calculateTaxAmount(item.net_amount, item.tax);
                }, 0);
            },
            TotalAmount() {
                return this.order_item_details.reduce((sum, item) => sum + item.total, 0);
            },
            totalDeliveryCharges() {
                return this.order_item_details.reduce((total, item) => {
                    return total + (item.delivery_charges || 0);
                }, 0);
            },
            grandTotalAmount() {
                return this.TotalAmount + this.totalDeliveryCharges;
            },
            grandTotalAmountInWords() {
                return this.numberToWords(Math.floor(this.TotalAmount)) + " only";
            },
        },
        methods: {
            calculateTaxAmount(netAmount, taxRate) {
                return (netAmount * taxRate) / 100;
            },
            formatVendorDetails(details) {
                return Object.entries(details)
                    .map(([key, value]) => `${key}: ${value}`)
                    .join("\n");
            },
            numberToWords(num) {
                if (num === 0) return "zero";

                const belowTwenty = [
                    "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine", "Ten",
                    "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen",
                    "Eighteen", "Nineteen",
                ];
                const tens = [
                    "", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety",
                ];
                const thousandPowers = ["", "Thousand", "Million", "Billion"];

                function convertChunk(num) {
                    let words = "";

                    if (num >= 100) {
                    words += belowTwenty[Math.floor(num / 100) - 1] + " Hundred ";
                    num %= 100;
                    }
                    if (num >= 20) {
                    words += tens[Math.floor(num / 10)] + " ";
                    num %= 10;
                    }
                    if (num > 0) {
                    words += belowTwenty[num - 1] + " ";
                    }

                    return words.trim();
                }

                let wordResult = "";
                let chunkIndex = 0;

                while (num > 0) {
                    if (num % 1000 !== 0) {
                    wordResult =
                        convertChunk(num % 1000) + " " + thousandPowers[chunkIndex] + " " + wordResult;
                    }
                    num = Math.floor(num / 1000);
                    chunkIndex++;
                }

                return wordResult.trim();
            },

            print() {
                this.$store.state.drawer = false;
                let that = this;
                window.onafterprint = function () {
                    that.$store.state.drawer = true;
                };
                setTimeout(function () {
                    window.print();
                }, 100);
            },
            onload(){               
                let formData = new FormData();
                formData.append("id",this.invoice_id)   
               
                this.overlay = true;
            axios
                .post("/EduStore/getViewInvoice", formData )
                .then((res) => {
                    this.overlay = false;
                    if (res.data.flag == "YES") {
                        this.overlay = false;
                        // this.showSnackbar("success", "data fetched successfully...");
                        this.stud_details = res.data.stud_details;
                        this.vendor_details = res.data.vendor_details;
                        this.order_details = res.data.order_details;
                        this.order_item_details = res.data.order_item_details;
                        this.qr_details = res.data.qr_details;

                    } else if (res.data.flag == "No") {
                        alert(res.data.snackbar)                        
                        this.showSnackbar("red", res.data.snackbar);
                    }                    
                    else {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    window.console.log(error);
                })
                .finally(() => {
                    this.overlay = false;
                });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        },
        
        mounted() {
            this.awspath = localStorage.getItem("awspath");
            this.invoice_id = localStorage.getItem("invoice_id");
            this.onload();            
        },
    };
</script>
<style scoped>
    tr,
    td,
    th {
        border: 1px solid black;
        text-align: center;
        font-size: small;
    }

    @media print {
        .no-display,
        .v-input__control,
        input[type="button"],
        input[type="submit"],
        input[type="reset"],
        #v-card {
            display: none !important;
        }
        .logo{
            margin-left: 5px;
        }
        .outer-div{
            max-width: 100% !important;
            margin: 0 !important;
            height: 100vh;
            font-size: 15px !important;
        }
        .header{
            font-size: 19px !important;           
        }
        .main{
            padding: 0px 7px !important;
        }
        .details-table th, .details-table td{
            padding: 1px !important;
            font-size: 10px !important;
        }
        .vendor-info{
            margin-left: -5px !important;
            margin-right: 30px !important;
        }
        th {
            white-space: nowrap;
        }
        .details-table {
            font-size: 10px !important;
        }
        @page {
            size: A4 !important;
            margin-top: none;
            padding-top: none;
        }
        .end-line{
            font-size: 10px !important;  
            margin-left: 5px;      
        }
        .sign{
            padding-left: 1055px !important;
        }
    }
    .tables {
        width: 35%;
        margin: auto;
        margin-top: 30px;
        border-collapse: collapse;
    }
    .tables th{
        background-color: goldenrod;
        color: white;
        border: 1px solid white;
    }
    .tables th, .tables td{
        padding: 8px;
    }
    .main {
        padding-left: 20px;
        padding-right: 20px;
    }
    .stud-details{
        margin-left: -90px !important;
    }
    .header{
        /* padding-bottom: 20px; */
        height: 40px;
        width: 99.3%;
        margin: auto;
        color: black;
        font-size: 24px;
       align-content: center;
       /* display: inline-block; */
       text-align: left;
       /* text-decoration: underline; */
    }
    .details-table{
        border: 1px solid rgb(183, 177, 177) !important;
        border-collapse: collapse;
        width: 100%;
        
    }
    .details-table td,.details-table th{
        padding: 8px;
        font-size: 14px;
    }
    .details-table th {
        background-color: darkslateblue;
        color: white;
        border: 1px solid white;
    }
    .end-line{
        font-size: 12px;        
    }
    .sign{
        padding-left: 975px !important;
    }
</style>
